

const BASE_URL = '/api/college_manage'
export const commonServer = {
  uploadFile: `${BASE_URL}/upload/file`,
  uploadDicom: `${BASE_URL}/upload/dicom`,
  uploadExcel: `${BASE_URL}/question/importExcel`
}


// WEBPACK FOOTER //
// ./src/api/server/common.js